module.exports = __webpack_public_path__ + "img/N134-2-EN.cfeeadd3.png";